import React, {Component, } from 'react';
import BaseUrlConfig from '../../../../net/BaseUrlConfig';

class ManualsAndPoliciesDashboard extends Component {
    render() {
        const activeProfile = BaseUrlConfig.profile;
        let ip = '192.168.213.27'
        if ((activeProfile === 'prodsh' || activeProfile === 'prodzj') ) {
            ip = '192.168.130.27'   
        }
        if (activeProfile === 'prodsg') {
            ip = '192.168.213.27'   
        }
        let name ='金伟伟'
        if ((activeProfile === 'prodsh' || activeProfile === 'prodzj') ) {
            name = '谢磊'   
        }
        let ename ='weiwei.jin'
        if ((activeProfile === 'prodsh' || activeProfile === 'prodzj') ) {
            ename = 'Xie Lei'   
        }
        return (
            
            <div>
                <style>
                {`            
                    .ManualsAndPoliciesDashboarddWrapper {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: left;
                        height: 100%;
                        width: 100%;
                        padding: 50px 50px;
                        font-size: 20px;
                    }
                `}
                </style>
                <div className='ManualsAndPoliciesDashboarddWrapper'>
                    <p>For Staff Manual and Company Policies, please visit 192.168.130.27 using the application "Remote Desktop Connection".</p>
                    <p>User ID: your desktop login ID</p>
                    <p>The password is provided on your onboarding day. For enquiries, please contact IT Team (Contact Person: {ename})</p>
                    <p></p>
                    <p>如您需要查阅《员工手册》或公司其他管理制度，请打开“远程桌面链接”，输入地址{ip}。</p>
                    <p>用户名：登录电脑的用户名</p>
                    <p>入职当天已提供密码。如有任何疑问，请联系IT组。（联络人: {name})</p>
                </div>
            </div>
        );
    };
}

export default ManualsAndPoliciesDashboard;
